// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.container {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    height: 100vh;
    row-gap: 24px;
}

.button {
    padding: 16px 12px;
    background-color: #F9C23A;
    text-align: center;
    border-radius: 8px;
    color: #1e1e1e;
    min-width: 150px;
}


.quiz {
    background-color: #FF8A00;
}

.button:hover {
    cursor: pointer;
    background-color: #ecb639;
    transition: background-color 300ms ease-in-out;
}`, "",{"version":3,"sources":["webpack://./src/pages/HomeScreen/HomeScreen.style.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,sBAAsB;IACtB,uBAAuB;IACvB,mBAAmB;IACnB,aAAa;IACb,aAAa;AACjB;;AAEA;IACI,kBAAkB;IAClB,yBAAyB;IACzB,kBAAkB;IAClB,kBAAkB;IAClB,cAAc;IACd,gBAAgB;AACpB;;;AAGA;IACI,yBAAyB;AAC7B;;AAEA;IACI,eAAe;IACf,yBAAyB;IACzB,8CAA8C;AAClD","sourcesContent":[".container {\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n    align-items: center;\n    height: 100vh;\n    row-gap: 24px;\n}\n\n.button {\n    padding: 16px 12px;\n    background-color: #F9C23A;\n    text-align: center;\n    border-radius: 8px;\n    color: #1e1e1e;\n    min-width: 150px;\n}\n\n\n.quiz {\n    background-color: #FF8A00;\n}\n\n.button:hover {\n    cursor: pointer;\n    background-color: #ecb639;\n    transition: background-color 300ms ease-in-out;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
